import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=5d3376a5&scoped=true"
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3376a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3376a5')) {
      api.createRecord('5d3376a5', component.options)
    } else {
      api.reload('5d3376a5', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=5d3376a5&scoped=true", function () {
      api.rerender('5d3376a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract/form/components/table_form.vue"
export default component.exports